module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/img-7-f1186d3f859c2adf34b369d8c7742aa0.png";